// Hugeicons Custom Collection: Bettermile
// Generated on: 2026-04-17T11:15:39.529Z

// TypeScript type definition for icon objects
import type { IconSvgObject } from '@/types/theme';

export const Book: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M17.858 2a.733.733 0 0 1 .735.732v1.221a13.732 13.732 0 0 1 3.347.403c.328.08.56.373.56.71v14.147a.732.732 0 0 1-.905.711c-3.005-.73-5.285-.239-6.803.412a8.464 8.464 0 0 0-1.72.98c-.19.143-.332.262-.422.344-.046.04-.078.072-.098.091l-.023.023a.733.733 0 0 1-1.058 0l-.023-.023c-.02-.019-.052-.05-.098-.091a6.032 6.032 0 0 0-.422-.343 8.463 8.463 0 0 0-1.72-.981c-1.518-.65-3.798-1.142-6.803-.412a.734.734 0 0 1-.905-.71V5.066l.01-.124a.732.732 0 0 1 .55-.587c3.344-.811 5.947-.274 7.726.488.842.36 1.494.77 1.95 1.104.886-1.619 2.247-2.583 3.429-3.145a9.57 9.57 0 0 1 1.811-.645 8.146 8.146 0 0 1 .734-.145l.047-.005.015-.002.005-.001h.002L17.858 2Zm-8.65 4.19c-1.422-.61-3.513-1.08-6.243-.536v12.66c2.911-.52 5.206-.016 6.821.676a10.25 10.25 0 0 1 1.481.783V7.443a6.289 6.289 0 0 0-.34-.272 8.468 8.468 0 0 0-1.719-.982Zm9.385-.773v10.485a.732.732 0 0 1-.5.695l-.002-.001-.004.002-.03.01-.123.047a11.357 11.357 0 0 0-2.048 1.076 9.89 9.89 0 0 0-1.447 1.167c1.6-.643 3.817-1.08 6.596-.584V5.654a11.972 11.972 0 0 0-2.442-.237Zm-1.465-1.785c-.373.102-.84.257-1.334.492-1.147.545-2.403 1.494-3.061 3.14v11.327a10.851 10.851 0 0 1 2.34-2.078 12.845 12.845 0 0 1 2.055-1.11V3.633ZM5.1 11.27c2.119 0 3.215.543 4.234 1.052a.732.732 0 1 1-.655 1.31c-.935-.468-1.792-.898-3.58-.898a.732.732 0 1 1 0-1.464Zm10.376-.204a.731.731 0 1 1 .628 1.321c-.457.217-.83.465-1.246.744a.73.73 0 1 1-.815-1.216c.41-.274.866-.58 1.433-.849ZM5.1 7.368c2.119 0 3.215.543 4.234 1.052a.732.732 0 1 1-.655 1.309c-.935-.467-1.792-.898-3.58-.898a.732.732 0 1 1 0-1.463Zm10.498-.43a.731.731 0 1 1 .504 1.374c-.696.254-1.184.578-1.737.948a.733.733 0 0 1-.815-1.217c.553-.37 1.171-.785 2.048-1.106Z',
      key: '0'
    }
  ]
];

export const CodeGeoApi: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M5.861 2a.769.769 0 0 1 0 1.538h-.512A1.28 1.28 0 0 0 4.07 4.821v4.444c0 .61-.197 1.204-.562 1.692L2.728 12l.78 1.043c.365.488.562 1.082.562 1.692v4.445a1.28 1.28 0 0 0 1.28 1.282h.511a.769.769 0 0 1 0 1.538h-.512a2.817 2.817 0 0 1-2.814-2.82v-4.445c0-.277-.09-.547-.255-.769l-1.127-1.504a.771.771 0 0 1 0-.924l1.127-1.504c.166-.222.255-.492.255-.77V4.822A2.818 2.818 0 0 1 5.35 2h.512Zm12.791 0a2.817 2.817 0 0 1 2.813 2.82v4.445c0 .277.09.547.256.769l1.125 1.504a.771.771 0 0 1 0 .924l-1.125 1.504a1.285 1.285 0 0 0-.256.77v4.444c0 1.557-1.26 2.82-2.813 2.82h-.512a.768.768 0 0 1 0-1.538h.512a1.28 1.28 0 0 0 1.279-1.282v-4.445c0-.61.197-1.204.562-1.692l.78-1.043-.78-1.043a2.826 2.826 0 0 1-.562-1.692V4.82a1.28 1.28 0 0 0-1.28-1.283h-.511a.768.768 0 0 1 0-1.538h.512Z',
      key: '0'
    }
  ],
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M12 4c2.485 0 4.5 2.062 4.5 4.606 0 2.296-1.642 4.2-3.79 4.548v6.119A.719.719 0 0 1 12 20a.719.719 0 0 1-.71-.727v-6.119c-2.148-.348-3.79-2.252-3.79-4.548C7.5 6.062 9.515 4 12 4Zm0 1.455c-1.7 0-3.079 1.41-3.079 3.151 0 1.74 1.379 3.152 3.079 3.152 1.7 0 3.079-1.411 3.079-3.152 0-1.74-1.379-3.151-3.079-3.151Z',
      'clip-rule': 'evenodd',
      fillRule: 'evenodd',
      key: '1'
    }
  ]
];

export const Logout: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M2 19.322V4.677C2 2.833 3.281 1 5.258 1h8.58c.447 0 .808.336.808.75s-.361.75-.807.75h-8.58c-.732 0-1.645.79-1.645 2.177v14.645c0 1.39.913 2.178 1.644 2.178h8.576c.445 0 .807.336.807.75s-.362.75-.807.75H5.258C3.281 23 2 21.167 2 19.322ZM16.332 7.483a.853.853 0 0 1 1.142 0l4.258 3.957a.804.804 0 0 1 .076.075l.02.023a.71.71 0 0 1-.064.992l-4.29 3.987a.853.853 0 0 1-1.142 0 .713.713 0 0 1 0-1.06l2.918-2.712H8.936c-.446 0-.807-.336-.807-.75s.361-.75.807-.75h10.303l-2.907-2.701a.713.713 0 0 1 0-1.06Z',
      key: '0'
    }
  ]
];

export const MenuCollapse: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M17.128 4c.425 0 .77.347.77.774a.772.772 0 0 1-.77.774H2.77A.772.772 0 0 1 2 4.774C2 4.347 2.344 4 2.77 4h14.358Zm-4.102 7.226c.425 0 .769.346.769.774a.772.772 0 0 1-.77.774H2.77A.772.772 0 0 1 2 12c0-.428.344-.774.77-.774h10.256Zm4.102 7.226c.425 0 .77.346.77.774a.772.772 0 0 1-.77.774H2.77a.772.772 0 0 1-.77-.774c0-.428.344-.774.77-.774h14.358Zm3.559-11.128a.766.766 0 0 1 1.088 0c.3.302.3.792 0 1.094L18.216 12l3.559 3.582c.3.302.3.792 0 1.094a.765.765 0 0 1-1.088 0l-4.103-4.129a.778.778 0 0 1 0-1.094l4.103-4.13Z',
      key: '0'
    }
  ]
];

export const MenuExpand: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M6.872 20a.772.772 0 0 1-.77-.774c0-.428.345-.774.77-.774H21.23c.425 0 .769.346.769.774a.772.772 0 0 1-.77.774H6.873Zm4.102-7.226a.772.772 0 0 1-.769-.774c0-.428.345-.774.77-.774H21.23c.425 0 .769.346.769.774a.772.772 0 0 1-.77.774H10.975ZM6.872 5.548a.772.772 0 0 1-.77-.774c0-.427.345-.774.77-.774H21.23c.425 0 .769.347.769.774a.772.772 0 0 1-.77.774H6.873ZM3.313 16.676a.766.766 0 0 1-1.088 0 .778.778 0 0 1 0-1.094L5.784 12 2.225 8.418a.778.778 0 0 1 0-1.094.766.766 0 0 1 1.088 0l4.103 4.129c.3.302.3.792 0 1.094l-4.103 4.13Z',
      key: '0'
    }
  ]
];

export const MobileShield: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M11.32 1.767a.767.767 0 0 1-.767.768H8.439l.454 1.36a.257.257 0 0 0 .244.175h1.416a.767.767 0 1 1 0 1.535H9.137A1.795 1.795 0 0 1 7.434 4.38l-.617-1.846H5.32a1.28 1.28 0 0 0-1.283 1.279v16.372c0 .706.574 1.28 1.283 1.28h10.256a1.28 1.28 0 0 0 1.282-1.28v-5.917a.77.77 0 0 1 1.538 0v5.917A2.817 2.817 0 0 1 15.577 23H5.32a2.817 2.817 0 0 1-2.82-2.814V3.814A2.817 2.817 0 0 1 5.32 1h5.233c.423 0 .767.344.767.767Zm.154 16.628a.768.768 0 1 1 0 1.535h-2.05a.768.768 0 1 1 0-1.535h2.05Z',
      key: '0'
    }
  ],
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M20.962 3.703a11.6 11.6 0 0 1-3.326-1.166l-.008-.002a11.6 11.6 0 0 1-3.333 1.168v2.232c0 1.2.6 2.158 1.366 2.897.718.693 1.534 1.142 1.967 1.352.433-.21 1.25-.659 1.967-1.352.766-.739 1.367-1.696 1.367-2.897V3.703ZM22.5 5.935c0 1.76-.89 3.09-1.835 4-.94.909-1.99 1.459-2.468 1.682-.362.17-.775.17-1.138 0-.477-.223-1.527-.773-2.468-1.682-.944-.91-1.834-2.24-1.835-4V3.666c0-.752.559-1.349 1.25-1.47l.47-.096a10.232 10.232 0 0 0 2.417-.916 1.562 1.562 0 0 1 1.47 0c.527.281 1.604.787 2.888 1.012.69.121 1.249.718 1.249 1.47v2.27Z',
      key: '1'
    }
  ]
];

export const Moon02: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M8.208 6.705c0-.886.127-1.743.364-2.553a8.503 8.503 0 0 0 3.55 16.226 8.502 8.502 0 0 0 7.725-4.951 9.09 9.09 0 0 1-11.64-8.722Zm1.621 0a7.467 7.467 0 0 0 10.978 6.59.811.811 0 0 1 1.172.9C20.93 18.668 16.916 22 12.122 22 6.532 22 2 17.468 2 11.878 2 7.084 5.332 3.07 9.805 2.02a.811.811 0 0 1 .9 1.172 7.432 7.432 0 0 0-.876 3.512Z',
      key: '0'
    }
  ]
];

export const PackageDelivered: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M6.541 13.71a.767.767 0 0 0 .686-1.373l-2.046-1.024a.768.768 0 0 0-.687 1.373l2.047 1.024Z',
      key: '0'
    }
  ],
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M10.977 23c.871 0 1.58-.306 2.625-.756.076-.034.155-.067.236-.101a.768.768 0 1 0-.607-1.41c-.699.3-1.141.49-1.487.6V11.67c.906-.17 1.847-.625 3.157-1.259l.17-.083 3.045-1.473a33.22 33.22 0 0 0 1.303-.655v2.777a.767.767 0 1 0 1.534 0V6.884a.76.76 0 0 0-.032-.208c.02-.096.032-.197.032-.304 0-.718-.496-1.175-.953-1.484-.456-.308-1.112-.625-1.884-1L15.07 2.417l-.17-.083C13.22 1.52 12.147 1 10.977 1s-2.244.52-3.924 1.333l-.17.083-2.99 1.446-.055.027c-.773.374-1.429.691-1.885 1C1.496 5.196 1 5.653 1 6.371c0 .107.012.208.032.304A.763.763 0 0 0 1 6.884V17.28c0 1.147.836 1.91 1.866 2.527 1.042.626 2.575 1.273 4.512 2.09l.063.028.153.065c1.452.615 2.388 1.01 3.383 1.01ZM4.562 7.5c-.843-.408-1.397-.678-1.75-.916a1.321 1.321 0 0 1-.26-.212c.035-.04.108-.11.26-.212.353-.238.907-.508 1.75-.916l2.99-1.447c1.91-.925 2.65-1.262 3.425-1.262.775 0 1.514.337 3.425 1.262l.004.003-8.603 4.302-1.24-.602Zm6.415 2.71c-.776 0-1.514-.338-3.426-1.263h-.005l8.604-4.303 1.241.6c.844.408 1.398.678 1.75.916.153.103.226.173.26.212-.034.04-.107.11-.26.212-.352.238-.906.508-1.75.916l-2.989 1.447c-1.911.925-2.65 1.262-3.425 1.262Zm-.768 11.14c-.49-.135-1.127-.398-2.17-.838-2.015-.851-3.446-1.457-4.384-2.02-.961-.577-1.12-.943-1.12-1.21V8.2c.374.203.815.419 1.303.655l3.045 1.473.17.083c1.31.634 2.25 1.09 3.156 1.26v9.68Z',
      'clip-rule': 'evenodd',
      fillRule: 'evenodd',
      key: '1'
    }
  ],
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M21.642 13.477a.767.767 0 0 1 1.081-.098.77.77 0 0 1 .098 1.084l-5.116 6.153a.767.767 0 0 1-1.132.052l-2.558-2.565a.77.77 0 0 1 0-1.087c.3-.3.785-.3 1.085 0l1.964 1.968 4.578-5.507Z',
      key: '2'
    }
  ]
];

export const Quiz: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M16.73 15.326c.425 0 .77.343.77.767a.769.769 0 0 1-.77.767H7.35a.769.769 0 0 1-.77-.767c0-.424.345-.767.77-.767h9.379Zm0-6.14a.77.77 0 0 1 .77.767.769.769 0 0 1-.77.768H7.35a.769.769 0 0 1-.77-.768.77.77 0 0 1 .77-.767h9.379Z',
      key: '0'
    }
  ],
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M14.568 1c1.005 0 1.859.641 2.176 1.535h1.932A2.82 2.82 0 0 1 21.5 5.349v14.837A2.82 2.82 0 0 1 18.676 23H5.324A2.82 2.82 0 0 1 2.5 20.186V5.349a2.82 2.82 0 0 1 2.824-2.814h1.932A2.309 2.309 0 0 1 9.432 1h5.136ZM5.324 4.07a1.28 1.28 0 0 0-1.283 1.279v14.837c0 .706.574 1.28 1.283 1.28h13.352c.709 0 1.284-.574 1.284-1.28V5.349c0-.707-.575-1.28-1.284-1.28h-1.932a2.309 2.309 0 0 1-2.176 1.536H9.432A2.309 2.309 0 0 1 7.256 4.07H5.324Zm4.108-1.535a.769.769 0 0 0-.77.767.77.77 0 0 0 .77.768h5.136a.769.769 0 1 0 0-1.535H9.432Z',
      'clip-rule': 'evenodd',
      fillRule: 'evenodd',
      key: '1'
    }
  ]
];

export const Refresh: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M22.307 12.26a.768.768 0 0 1 .689.84c-.553 5.558-5.253 9.9-10.971 9.9a11.025 11.025 0 0 1-9.487-5.393v3.602a.768.768 0 0 1-1.538 0v-4.502a1.38 1.38 0 0 1 1.384-1.381h4.513a.768.768 0 1 1 0 1.534H3.885a9.486 9.486 0 0 0 8.14 4.605c4.92 0 8.965-3.736 9.44-8.518a.769.769 0 0 1 .842-.687ZM11.975 1c2.145 0 4.245.623 6.04 1.796a11.012 11.012 0 0 1 3.447 3.597V2.791a.768.768 0 0 1 1.538 0v4.502a1.38 1.38 0 0 1-1.385 1.381h-4.512a.768.768 0 1 1 0-1.534h3.013a9.472 9.472 0 0 0-7.796-4.6l-.345-.005c-4.92 0-8.966 3.736-9.44 8.518a.769.769 0 0 1-1.531-.152C1.556 5.34 6.258 1 11.974 1Z',
      key: '0'
    }
  ]
];

export const Report: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M16.73 11.16c.425 0 .77.37.77.825 0 .455-.345.825-.77.825H7.095c-.426 0-.77-.37-.77-.825 0-.456.344-.825.77-.825h9.635Zm0-5.16c.425 0 .77.37.77.825 0 .456-.345.825-.77.825H7.095c-.426 0-.77-.37-.77-.825 0-.456.344-.825.77-.825h9.635Z',
      key: '0'
    }
  ],
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M14.38 1h4.296c1.56 0 2.824 1.354 2.824 3.025v15.95c0 1.67-1.265 3.025-2.824 3.025H5.324C3.764 23 2.5 21.646 2.5 19.975V4.025C2.5 2.355 3.764 1 5.324 1h9.055ZM5.324 2.65c-.709 0-1.283.616-1.283 1.375v15.95c0 .76.574 1.375 1.283 1.375h13.352c.709 0 1.284-.616 1.284-1.375V4.025c0-.76-.575-1.375-1.284-1.375H5.324Z',
      'clip-rule': 'evenodd',
      fillRule: 'evenodd',
      key: '1'
    }
  ],
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M13.784 16.075c.425 0 .77.37.77.825 0 .456-.345.825-.77.825h-6.69c-.425 0-.77-.37-.77-.825 0-.456.345-.825.77-.825h6.69Z',
      key: '2'
    }
  ]
];

export const RouteComplete: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M5.846 15.326a3.842 3.842 0 0 1 3.846 3.837A3.842 3.842 0 0 1 5.846 23 3.842 3.842 0 0 1 2 19.163a3.842 3.842 0 0 1 3.846-3.837Zm0 1.534a2.305 2.305 0 0 0-2.308 2.303 2.305 2.305 0 0 0 2.308 2.302 2.305 2.305 0 0 0 2.308-2.302 2.305 2.305 0 0 0-2.308-2.303Z',
      'clip-rule': 'evenodd',
      fillRule: 'evenodd',
      key: '0'
    }
  ],
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M12 4.07a.768.768 0 1 1 0 1.535H8.41a2.817 2.817 0 0 0-2.82 2.814 2.817 2.817 0 0 0 2.82 2.813h7.18a4.354 4.354 0 0 1 4.359 4.35 4.354 4.354 0 0 1-4.36 4.348H12a.768.768 0 1 1 0-1.535h3.59c1.558 0 2.82-1.26 2.82-2.814a2.817 2.817 0 0 0-2.82-2.814H8.41A4.354 4.354 0 0 1 4.051 8.42a4.354 4.354 0 0 1 4.36-4.35H12Zm10.643-2.797a.773.773 0 0 1 1.081-.097c.326.269.37.749.098 1.071l-5.116 6.08a.77.77 0 0 1-1.132.05l-2.559-2.533a.755.755 0 0 1 0-1.075.773.773 0 0 1 1.086 0l1.963 1.945 4.579-5.44Z',
      key: '1'
    }
  ]
];

export const ShoppingBasket: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M12 1c3.135 0 5.676 2.405 5.676 5.372v.768h3.514a.83.83 0 0 1 .612.264.74.74 0 0 1 .19.612l-1.896 12.568C19.886 21.97 18.632 23 17.152 23H6.848c-1.48 0-2.733-1.03-2.943-2.416L2.008 8.016a.74.74 0 0 1 .19-.612.83.83 0 0 1 .613-.264h3.513v-.768C6.324 3.405 8.865 1 12 1ZM3.746 8.674 5.51 20.367c.095.63.665 1.098 1.338 1.098h10.304c.673 0 1.243-.468 1.338-1.098l1.765-11.693H3.746ZM12 2.534c-2.239 0-4.054 1.719-4.054 3.838v.768h8.108v-.768c0-2.12-1.815-3.837-4.054-3.837Z',
      'clip-rule': 'evenodd',
      fillRule: 'evenodd',
      key: '0'
    }
  ]
];

export const Warehouse: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M13.024 5.597a.768.768 0 0 1 0 1.537h-2.048a.769.769 0 0 1 0-1.537h2.048Z',
      key: '0'
    }
  ],
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M10.907 1.72a2.818 2.818 0 0 1 2.186 0l7.683 3.235A2.818 2.818 0 0 1 22.5 7.552v14.18a.769.769 0 0 1-.768.768H2.268a.769.769 0 0 1-.768-.769V7.552a2.82 2.82 0 0 1 1.724-2.597l7.683-3.234Zm1.59 1.416a1.282 1.282 0 0 0-.994 0L3.82 6.372a1.28 1.28 0 0 0-.783 1.18v13.411h1.536V11.99c0-.99.803-1.793 1.793-1.793h11.268c.99 0 1.793.803 1.793 1.793v8.974h1.536V7.552c0-.515-.308-.98-.783-1.18l-7.683-3.236ZM6.11 16.96v4.004h11.78V16.96H6.11Zm.256-5.226a.256.256 0 0 0-.256.256v3.433h11.78V11.99a.256.256 0 0 0-.256-.256H6.366Z',
      'clip-rule': 'evenodd',
      fillRule: 'evenodd',
      key: '1'
    }
  ]
];

export const Union: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M3.818 5.377c0-.99.803-1.793 1.793-1.793h9.635c.99 0 1.793.804 1.792 1.795l-.003 2.561a1.792 1.792 0 0 1-1.792 1.791H5.61c-.99 0-1.793-.803-1.793-1.793V5.377Zm1.536 2.561c0 .142.115.256.257.256h9.632a.257.257 0 0 0 .256-.256l.002-2.56a.256.256 0 0 0-.255-.257H5.61a.256.256 0 0 0-.257.256v2.561ZM3.818 13.06c0-.99.803-1.792 1.793-1.792h9.62c.99 0 1.793.803 1.793 1.793v2.561c0 .99-.803 1.793-1.793 1.793H5.61c-.99 0-1.793-.803-1.793-1.793v-2.561Zm1.536 2.562c0 .142.115.256.257.256h9.62a.256.256 0 0 0 .256-.256v-2.561a.256.256 0 0 0-.256-.256H5.61a.256.256 0 0 0-.257.256v2.561Z',
      'clip-rule': 'evenodd',
      fillRule: 'evenodd',
      key: '0'
    }
  ],
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M0 2.817A2.817 2.817 0 0 1 2.817 0h15.366A2.817 2.817 0 0 1 21 2.817v15.366A2.817 2.817 0 0 1 18.183 21H2.817A2.817 2.817 0 0 1 0 18.183V2.817Zm1.536 15.366c0 .707.574 1.28 1.281 1.28h15.366a1.28 1.28 0 0 0 1.28-1.28V2.817a1.28 1.28 0 0 0-1.28-1.28H2.817a1.28 1.28 0 0 0-1.28 1.28v15.366Z',
      'clip-rule': 'evenodd',
      fillRule: 'evenodd',
      key: '1'
    }
  ]
];

export const ShipmentFailed: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M7.907 14.303a.767.767 0 1 1 0 1.534H5.86a.768.768 0 0 1 0-1.534h2.047Z',
      key: '0'
    }
  ],
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M10.977 11.232c.989 0 1.79.803 1.79 1.792v8.185A1.79 1.79 0 0 1 10.977 23H2.79A1.791 1.791 0 0 1 1 21.21v-8.187c0-.989.802-1.79 1.791-1.79h8.186ZM2.79 12.768a.256.256 0 0 0-.256.255v8.186c0 .141.115.256.256.256h8.186a.256.256 0 0 0 .255-.256v-8.185a.256.256 0 0 0-.255-.256H2.79Z',
      'clip-rule': 'evenodd',
      fillRule: 'evenodd',
      key: '1'
    }
  ],
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M18.14 11.291c.424 0 .768.344.768.768v8.127A2.815 2.815 0 0 1 16.094 23h-1.535a.768.768 0 0 1 0-1.535h1.535a1.28 1.28 0 0 0 1.279-1.28V12.06c0-.424.344-.768.768-.768Zm3.378-10.037a.87.87 0 0 1 1.227 0c.34.338.34.887 0 1.226l-2.86 2.853 2.86 2.855c.34.338.34.887 0 1.225a.87.87 0 0 1-1.227 0L18.656 6.56l-2.86 2.854a.87.87 0 0 1-1.229 0 .865.865 0 0 1 0-1.225l2.86-2.855-2.86-2.853a.865.865 0 0 1 0-1.226.87.87 0 0 1 1.229 0l2.86 2.853 2.862-2.853Z',
      key: '2'
    }
  ]
];

export const ShipmentTracking: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M7.907 14.303a.768.768 0 1 1 0 1.534H5.86a.768.768 0 0 1 0-1.534h2.047Z',
      key: '0'
    }
  ],
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M10.977 11.232c.989 0 1.79.803 1.79 1.791v8.186A1.79 1.79 0 0 1 10.977 23H2.79A1.791 1.791 0 0 1 1 21.209v-8.186c0-.989.802-1.79 1.791-1.79h8.186ZM2.79 12.768a.256.256 0 0 0-.256.255v8.186c0 .141.115.256.256.256h8.186a.256.256 0 0 0 .255-.256v-8.186a.256.256 0 0 0-.255-.255H2.79Z',
      'clip-rule': 'evenodd',
      fillRule: 'evenodd',
      key: '1'
    }
  ],
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M18.14 13.791c.423 0 .767.343.767.767l.001 5.628A2.814 2.814 0 0 1 16.094 23h-1.535a.768.768 0 0 1 0-1.535h1.535a1.28 1.28 0 0 0 1.279-1.28V14.56a.767.767 0 0 1 .767-.768Zm.008-8.954a1.024 1.024 0 0 1 0 2.047h-.008a1.024 1.024 0 0 1 0-2.047h.008Z',
      key: '2'
    }
  ],
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M18.14 1C20.83 1 23 3.202 23 5.901c0 1.641-.851 2.838-1.747 3.813-.284.31-.6.623-.9.923-.16.16-.316.315-.46.463-.437.447-.818.872-1.11 1.32a.768.768 0 0 1-1.299-.02c-.278-.457-.649-.883-1.079-1.325-.161-.166-.349-.35-.543-.542a31.078 31.078 0 0 1-.812-.821c-.902-.96-1.77-2.14-1.77-3.81 0-2.7 2.168-4.902 4.86-4.902Zm0 1.535c-1.83 0-3.326 1.5-3.327 3.366 0 1.074.533 1.886 1.355 2.76.247.263.481.492.726.733.193.19.393.386.612.61.218.226.438.463.648.714.209-.242.425-.472.64-.692.177-.18.348-.35.514-.515.281-.28.55-.548.814-.836.817-.889 1.343-1.72 1.343-2.774 0-1.866-1.496-3.366-3.325-3.366Z',
      'clip-rule': 'evenodd',
      fillRule: 'evenodd',
      key: '3'
    }
  ]
];

export const ArrowChartDown: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M8.238 14.007a.7.7 0 0 0 .512.212.745.745 0 0 0 .52-.228l4.188-4.308 6.574 6.76-3.663.057a.742.742 0 0 0-.718.76.74.74 0 0 0 .74.74l5.307-.082a.74.74 0 0 0 .719-.739l.083-5.68a.741.741 0 0 0-.719-.762.74.74 0 0 0-.74.74l-.056 3.794-6.989-7.187a.715.715 0 0 0-1.03.016l-4.189 4.308-6.024-6.196a.715.715 0 0 0-1.031.016.766.766 0 0 0-.016 1.06l6.532 6.719Z',
      key: '0'
    }
  ]
];

export const ArrowChartUp: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M8.238 9.993a.7.7 0 0 1 .512-.212.745.745 0 0 1 .52.228l4.188 4.308 6.574-6.76-3.663-.057a.742.742 0 0 1-.718-.76.74.74 0 0 1 .74-.74l5.307.082a.74.74 0 0 1 .719.739l.083 5.68a.741.741 0 0 1-.719.762.74.74 0 0 1-.74-.74l-.056-3.794-6.989 7.187a.715.715 0 0 1-1.03-.016l-4.189-4.308-6.024 6.196a.715.715 0 0 1-1.031-.015.766.766 0 0 1-.016-1.061l6.532-6.719Z',
      key: '0'
    }
  ]
];

export const DisplayVertical: IconSvgObject = [
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M17.123 5.318c.99 0 1.793.803 1.793 1.793v9.635c0 .99-.804 1.793-1.795 1.792l-2.561-.003a1.792 1.792 0 0 1-1.791-1.792V7.11c0-.99.803-1.793 1.793-1.793h2.561Zm-2.561 1.536a.256.256 0 0 0-.256.257v9.632c0 .141.114.256.256.256l2.56.002a.256.256 0 0 0 .257-.255V7.11a.256.256 0 0 0-.256-.257h-2.561ZM9.44 5.318c.99 0 1.792.803 1.792 1.793v9.62c0 .99-.803 1.793-1.793 1.793H6.878c-.99 0-1.793-.803-1.793-1.793V7.11c0-.99.803-1.793 1.793-1.793h2.561ZM6.877 6.854a.256.256 0 0 0-.256.257v9.62c0 .141.114.256.256.256h2.561a.256.256 0 0 0 .256-.256V7.11a.256.256 0 0 0-.256-.257h-2.56Z',
      'clip-rule': 'evenodd',
      fillRule: 'evenodd',
      key: '0'
    }
  ],
  [
    'path',
    {
      fill: 'currentColor',
      'fill-opacity': '.9',
      d: 'M19.683 1.5A2.817 2.817 0 0 1 22.5 4.317v15.366a2.817 2.817 0 0 1-2.817 2.817H4.317A2.817 2.817 0 0 1 1.5 19.683V4.317A2.817 2.817 0 0 1 4.317 1.5h15.366ZM4.317 3.036a1.28 1.28 0 0 0-1.28 1.281v15.366c0 .707.573 1.28 1.28 1.28h15.366a1.28 1.28 0 0 0 1.28-1.28V4.317a1.28 1.28 0 0 0-1.28-1.28H4.317Z',
      'clip-rule': 'evenodd',
      fillRule: 'evenodd',
      key: '1'
    }
  ]
];

export const TruckBack: IconSvgObject = [
  [
    'path',
    {
      'clip-rule': 'evenodd',
      d: 'M13.0244 3C14.0134 3.00006 14.8154 3.80671 14.8154 4.80078V5.05762H18.0049C18.9933 5.05762 19.9103 5.57881 20.4189 6.43066L22.8926 10.5752C22.9096 10.6037 22.9236 10.6334 22.9365 10.6631C22.9393 10.6694 22.9427 10.6762 22.9453 10.6826C22.9571 10.7118 22.9637 10.7426 22.9717 10.7725C22.9781 10.7966 22.9861 10.8207 22.9902 10.8457C22.9919 10.8558 22.9938 10.8658 22.9951 10.876C22.999 10.9072 23.0019 10.9394 23.002 10.9717V17.1436C23.0018 18.1376 22.1999 18.9434 21.2109 18.9434H19.8232C19.4889 20.13 18.4058 20.9998 17.1182 21C15.8303 21 14.7465 20.1302 14.4121 18.9434H9.58984C9.2555 20.1302 8.17167 21 6.88379 21C5.58778 20.9998 4.49953 20.1184 4.17285 18.9199L2.80859 18.9336C1.81359 18.9424 1.0022 18.1339 1.00195 17.1338V12.2891C1.002 11.8631 1.34568 11.5176 1.76953 11.5176C2.19335 11.5176 2.53706 11.8631 2.53711 12.2891V17.1338C2.53736 17.2764 2.65302 17.3927 2.79492 17.3916L4.18359 17.3779C4.52507 16.2025 5.60408 15.3439 6.88379 15.3438C8.17167 15.3438 9.2555 16.2136 9.58984 17.4004H14.4121C14.7465 16.2136 15.8303 15.3438 17.1182 15.3438C18.4058 15.344 19.4889 16.2137 19.8232 17.4004H21.2109C21.3521 17.4004 21.4667 17.2855 21.4668 17.1436V11.7432H15.0713C14.0822 11.7432 13.2803 10.9374 13.2803 9.94336V4.80078C13.2803 4.6588 13.1657 4.54303 13.0244 4.54297H10.3623C9.93862 4.54273 9.5957 4.19739 9.5957 3.77148C9.59591 3.34576 9.93875 3.00024 10.3623 3H13.0244ZM6.88379 16.8857C6.17751 16.886 5.60547 17.4619 5.60547 18.1719C5.60547 18.8818 6.17751 19.4578 6.88379 19.458C7.59026 19.458 8.16308 18.882 8.16309 18.1719C8.16309 17.4618 7.59026 16.8857 6.88379 16.8857ZM17.1182 16.8857C16.4117 16.8857 15.8389 17.4618 15.8389 18.1719C15.8389 18.882 16.4117 19.458 17.1182 19.458C17.8244 19.4578 18.3965 18.8818 18.3965 18.1719C18.3965 17.462 17.8244 16.886 17.1182 16.8857ZM14.8154 9.94336C14.8155 10.0853 14.93 10.2002 15.0713 10.2002H20.8779L19.1025 7.22461C18.8713 6.83756 18.4541 6.60059 18.0049 6.60059H14.8154V9.94336Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      fillRule: 'evenodd',
      key: '0'
    }
  ],
  [
    'path',
    {
      d: 'M3.95898 4.16113C4.28397 3.9048 4.75506 3.96037 5.01172 4.28516C5.26845 4.61018 5.21366 5.08211 4.88867 5.33887L3.41797 6.5H10.5576C10.9718 6.50001 11.3076 6.83581 11.3076 7.25C11.3076 7.66421 10.9718 7.99999 10.5576 8H3.41797L4.88867 9.16113C5.21369 9.41788 5.26845 9.88981 5.01172 10.2148C4.75506 10.5397 4.28398 10.5952 3.95898 10.3389L2.47168 9.16406C2.45932 9.1543 2.44685 9.14447 2.43457 9.13477C2.07117 8.8478 1.74017 8.58726 1.50684 8.3457C1.25963 8.08978 1 7.73431 1 7.25C1.00001 6.766 1.25977 6.41115 1.50684 6.15527C1.74018 5.91371 2.07116 5.65221 2.43457 5.36523C2.44686 5.35553 2.45931 5.34571 2.47168 5.33594L3.95898 4.16113Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      key: '1'
    }
  ]
];

export const TruckClock: IconSvgObject = [
  [
    'path',
    {
      'clip-rule': 'evenodd',
      d: 'M13.0234 4C14.0122 4.00012 14.8134 4.80586 14.8135 5.7998V6.05762H18.0039C18.9921 6.05773 19.9085 6.5789 20.417 7.43066L22.8906 11.5742C22.9077 11.6028 22.9216 11.6333 22.9346 11.6631C22.9373 11.6694 22.9408 11.6762 22.9434 11.6826C22.955 11.7116 22.9617 11.7418 22.9697 11.7715C22.9762 11.7957 22.9841 11.8196 22.9883 11.8447C22.99 11.8551 22.9919 11.8655 22.9932 11.876C22.997 11.9073 23 11.9393 23 11.9717V18.1426C23 19.1367 22.198 19.9424 21.209 19.9424H19.8213C19.487 21.1292 18.404 22 17.1162 22C15.8285 22 14.7454 21.1292 14.4111 19.9424H9.58887C9.25456 21.1292 8.1715 21.9999 6.88379 22C5.58779 22 4.49961 21.1184 4.17285 19.9199L2.80859 19.9326C1.8136 19.9415 1.0022 19.134 1.00195 18.1338V12.7539C1.00207 12.328 1.34576 11.9824 1.76953 11.9824C2.19324 11.9825 2.537 12.328 2.53711 12.7539V18.1338C2.53736 18.2764 2.65303 18.3918 2.79492 18.3906L4.18359 18.3779C4.52499 17.2023 5.60391 16.3428 6.88379 16.3428C8.1715 16.3428 9.25456 17.2136 9.58887 18.4004H14.4111C14.7454 17.2136 15.8285 16.3428 17.1162 16.3428C18.404 16.3428 19.487 17.2136 19.8213 18.4004H21.209C21.3503 18.4004 21.4648 18.2846 21.4648 18.1426V12.7432H15.0693C14.0805 12.743 13.2793 11.9364 13.2793 10.9424V5.7998C13.2792 5.65795 13.1645 5.54309 13.0234 5.54297H12.6006C12.1768 5.54297 11.833 5.19751 11.833 4.77148C11.833 4.34544 12.1767 4 12.6006 4H13.0234ZM6.88379 17.8857C6.17738 17.8857 5.60449 18.4618 5.60449 19.1719C5.60473 19.8818 6.17753 20.457 6.88379 20.457C7.59 20.457 8.16285 19.8817 8.16309 19.1719C8.16309 18.4618 7.59015 17.8858 6.88379 17.8857ZM17.1162 17.8857C16.4098 17.8858 15.8369 18.4618 15.8369 19.1719C15.8372 19.8817 16.41 20.457 17.1162 20.457C17.8225 20.457 18.3953 19.8818 18.3955 19.1719C18.3955 18.4618 17.8226 17.8857 17.1162 17.8857ZM14.8135 10.9424C14.8135 11.0843 14.9282 11.2 15.0693 11.2002H20.877L19.1006 8.22363C18.8694 7.83679 18.4529 7.59972 18.0039 7.59961H14.8135V10.9424Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      fillRule: 'evenodd',
      key: '0'
    }
  ],
  [
    'path',
    {
      d: 'M6.25 4.7002C6.66421 4.7002 7 5.03598 7 5.4502V7.29883L8.01562 7.97559C8.36024 8.20533 8.45332 8.67099 8.22363 9.01562C7.99387 9.36027 7.52824 9.4534 7.18359 9.22363L5.83398 8.32422C5.62539 8.18516 5.50007 7.95089 5.5 7.7002V5.4502C5.5 5.03598 5.83579 4.7002 6.25 4.7002Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      key: '1'
    }
  ],
  [
    'path',
    {
      'clip-rule': 'evenodd',
      d: 'M6.25 2C9.1495 2 11.5 4.3505 11.5 7.25C11.5 10.1495 9.1495 12.5 6.25 12.5C3.3505 12.5 1 10.1495 1 7.25C1 4.3505 3.3505 2 6.25 2ZM6.25 3.5C4.17893 3.5 2.5 5.17893 2.5 7.25C2.5 9.32107 4.17893 11 6.25 11C8.32107 11 10 9.32107 10 7.25C10 5.17893 8.32107 3.5 6.25 3.5Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      fillRule: 'evenodd',
      key: '2'
    }
  ]
];

export const TruckPin: IconSvgObject = [
  [
    'path',
    {
      'clip-rule': 'evenodd',
      d: 'M13.0233 3C14.0122 3 14.814 3.80589 14.814 4.8V5.05714H18.0036C18.992 5.05715 19.9083 5.57839 20.4169 6.43025L22.8911 10.5747C22.9082 10.6033 22.922 10.6332 22.935 10.6631C22.9378 10.6694 22.9405 10.6757 22.943 10.6821C22.9549 10.7114 22.962 10.7416 22.97 10.7715C22.9765 10.7958 22.9839 10.8198 22.988 10.8449C22.9897 10.8553 22.9917 10.8656 22.993 10.876C22.9969 10.9073 23 10.9391 23 10.9714V17.1429C23 18.137 22.1983 18.9429 21.2093 18.9429H19.8213C19.487 20.1297 18.404 21 17.1163 21C15.8285 21 14.7456 20.1297 14.4112 18.9429H9.58875C9.25444 20.1297 8.17149 21 6.88372 21C5.58764 21 4.49938 20.1183 4.17269 18.9198L2.80868 18.9328C1.81367 18.9418 1.00224 18.134 1.002 17.1338V11.8599C1.002 11.4339 1.34559 11.0885 1.76944 11.0885C2.19328 11.0885 2.53688 11.4339 2.53688 11.8599V17.1338C2.53713 17.2764 2.65281 17.3921 2.79469 17.391L4.18368 17.3779C4.52508 16.2022 5.60384 15.3429 6.88372 15.3429C8.17149 15.3429 9.25444 16.2132 9.58875 17.4H14.4112C14.7456 16.2132 15.8285 15.3429 17.1163 15.3429C18.404 15.3429 19.487 16.2132 19.8213 17.4H21.2093C21.3506 17.4 21.4651 17.2849 21.4651 17.1429V11.7429H15.0698C14.0808 11.7429 13.2791 10.937 13.2791 9.94286V4.8C13.2791 4.65798 13.1645 4.54286 13.0233 4.54286H11.9544C11.5306 4.54286 11.187 4.19748 11.187 3.77143C11.187 3.34538 11.5306 3 11.9544 3H13.0233ZM6.88372 16.8857C6.17731 16.8857 5.60465 17.4613 5.60465 18.1714C5.60465 18.8815 6.17731 19.4571 6.88372 19.4571C7.59013 19.4571 8.16279 18.8815 8.16279 18.1714C8.16279 17.4613 7.59013 16.8857 6.88372 16.8857ZM17.1163 16.8857C16.4099 16.8857 15.8372 17.4613 15.8372 18.1714C15.8372 18.8815 16.4099 19.4571 17.1163 19.4571C17.8227 19.4571 18.3953 18.8815 18.3953 18.1714C18.3953 17.4613 17.8227 16.8857 17.1163 16.8857ZM14.814 9.94286C14.814 10.0849 14.9285 10.2 15.0698 10.2H20.8765L19.1008 7.22377C18.8696 6.83672 18.4528 6.6 18.0036 6.6H14.814V9.94286Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      fillRule: 'evenodd',
      key: '0'
    }
  ],
  [
    'path',
    {
      d: 'M5.86946 4.83721C6.43459 4.83721 6.89271 5.29534 6.89271 5.86047C6.89271 6.42559 6.43459 6.88372 5.86946 6.88372H5.86047C5.29534 6.88372 4.83721 6.42559 4.83721 5.86047C4.83721 5.29534 5.29534 4.83721 5.86047 4.83721H5.86946Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      key: '1'
    }
  ],
  [
    'path',
    {
      'clip-rule': 'evenodd',
      d: 'M5.86047 1C8.55372 1 10.7208 3.20792 10.7209 5.91143C10.7209 7.48324 9.91749 8.73781 9.05214 9.63372C8.18466 10.5318 7.18838 11.1414 6.6369 11.4424C6.15073 11.7077 5.5702 11.7077 5.08403 11.4424C4.53255 11.1414 3.53627 10.5318 2.66879 9.63372C1.80344 8.73781 1 7.48324 1 5.91143C1.00011 3.20792 3.16721 1 5.86047 1ZM5.86047 2.53488C4.03282 2.53488 2.53499 4.03758 2.53488 5.91143C2.53488 6.9322 3.05527 7.82443 3.77298 8.5675C4.48851 9.30823 5.33479 9.83084 5.81949 10.0954C5.83552 10.1041 5.84932 10.1064 5.86047 10.1064C5.87161 10.1064 5.88541 10.1041 5.90144 10.0954C6.38614 9.83084 7.23242 9.30823 7.94795 8.5675C8.66566 7.82443 9.18605 6.9322 9.18605 5.91143C9.18594 4.03758 7.68811 2.53488 5.86047 2.53488Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      fillRule: 'evenodd',
      key: '2'
    }
  ]
];

export const SmartPhone04: IconSvgObject = [
  [
    'path',
    {
      'clip-rule': 'evenodd',
      d: 'M14.0465 1C15.6006 1 16.8605 2.25985 16.8605 3.81395V5.86047C16.8605 6.28431 16.5169 6.62791 16.093 6.62791C15.6692 6.62791 15.3256 6.28431 15.3256 5.86047V3.81395C15.3256 3.10754 14.7529 2.53488 14.0465 2.53488H12.5546L12.1719 3.68305C12.1681 3.6945 12.1647 3.70662 12.1609 3.71802C12.0582 4.02607 11.9616 4.31525 11.8531 4.54842C11.7323 4.80816 11.5658 5.0686 11.2865 5.26989C11.0075 5.47088 10.7085 5.54617 10.4241 5.57867C10.1687 5.60784 9.86343 5.60769 9.53879 5.60765H8.32367C7.99907 5.60769 7.69379 5.6078 7.43832 5.57867C7.15379 5.54619 6.85414 5.47103 6.57495 5.26989C6.29567 5.0686 6.12919 4.80816 6.00836 4.54842C5.89993 4.31533 5.80418 4.02594 5.70158 3.71802C5.69778 3.70662 5.69341 3.6945 5.68959 3.68305L5.30687 2.53488H3.81395C3.10754 2.53488 2.53488 3.10754 2.53488 3.81395V20.186C2.53488 20.8925 3.10754 21.4651 3.81395 21.4651H14.0465C14.7529 21.4651 15.3256 20.8925 15.3256 20.186V18.1395C15.3256 17.7157 15.6692 17.3721 16.093 17.3721C16.5169 17.3721 16.8605 17.7157 16.8605 18.1395V20.186C16.8605 21.7401 15.6006 23 14.0465 23H3.81395C2.25985 23 1 21.7401 1 20.186V3.81395C1 2.25985 2.25985 1 3.81395 1H14.0465ZM7.14553 3.1984C7.26361 3.55265 7.33332 3.7568 7.40035 3.90089C7.4304 3.96549 7.45112 3.99777 7.4623 4.01281C7.46745 4.01971 7.47129 4.0238 7.47129 4.0238L7.47229 4.0248C7.47229 4.0248 7.4781 4.02709 7.48628 4.0298C7.50403 4.03564 7.5412 4.04567 7.61219 4.05378C7.7701 4.07179 7.98619 4.07277 8.35965 4.07277H9.50182C9.87514 4.07277 10.0914 4.07177 10.2493 4.05378C10.3201 4.0457 10.3574 4.03565 10.3752 4.0298C10.3833 4.0271 10.3882 4.0248 10.3882 4.0248L10.3902 4.0238C10.3902 4.0238 10.394 4.01971 10.3992 4.01281C10.4103 3.9978 10.431 3.96561 10.4611 3.90089C10.5281 3.7568 10.5978 3.55267 10.7159 3.1984L10.9368 2.53488H6.92469L7.14553 3.1984Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      fillRule: 'evenodd',
      key: '0'
    }
  ],
  [
    'path',
    {
      d: 'M9.95349 18.3953C10.3773 18.3953 10.7209 18.7389 10.7209 19.1628C10.7209 19.5866 10.3773 19.9302 9.95349 19.9302H7.90698C7.48313 19.9302 7.13953 19.5866 7.13953 19.1628C7.13953 18.7389 7.48313 18.3953 7.90698 18.3953H9.95349Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      key: '1'
    }
  ],
  [
    'path',
    {
      d: 'M19.6804 6.86573C19.9731 6.55922 20.4591 6.54802 20.7656 6.84075C22.1406 8.15405 23 9.9783 23 12C23 14.0217 22.1406 15.846 20.7656 17.1592C20.4591 17.452 19.9731 17.4408 19.6804 17.1343C19.388 16.8278 19.3991 16.3427 19.7054 16.0501C20.7981 15.0065 21.4651 13.5746 21.4651 12C21.4651 10.4254 20.7981 8.9935 19.7054 7.94995C19.3992 7.65727 19.388 7.1722 19.6804 6.86573Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      key: '2'
    }
  ],
  [
    'path',
    {
      d: 'M17.5849 9.16806C17.8777 8.86155 18.3626 8.85037 18.6691 9.14308C19.4273 9.86718 19.9053 10.8773 19.9053 12C19.9053 13.1227 19.4273 14.1328 18.6691 14.8569C18.3626 15.1496 17.8777 15.1385 17.5849 14.8319C17.2922 14.5254 17.3034 14.0405 17.6099 13.7477C18.0856 13.2934 18.3704 12.6755 18.3704 12C18.3704 11.3245 18.0856 10.7066 17.6099 10.2523C17.3034 9.95955 17.2922 9.47458 17.5849 9.16806Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      key: '3'
    }
  ],
  [
    'path',
    {
      d: 'M16.093 10.9688C16.6582 10.9688 17.1163 11.4269 17.1163 11.992V12.001C17.1163 12.5661 16.6582 13.0243 16.093 13.0243C15.5279 13.0243 15.0698 12.5661 15.0698 12.001V11.992C15.0698 11.4269 15.5279 10.9688 16.093 10.9688Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      key: '4'
    }
  ]
];

export const SmartPhone01: IconSvgObject = [
  [
    'path',
    {
      d: 'M13.0323 18.3953C13.4598 18.3953 13.8065 18.7389 13.8065 19.1628C13.8065 19.5866 13.4598 19.9302 13.0323 19.9302H10.9677C10.5402 19.9302 10.1935 19.5866 10.1935 19.1628C10.1935 18.7389 10.5402 18.3953 10.9677 18.3953H13.0323Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      key: '0'
    }
  ],
  [
    'path',
    {
      'clip-rule': 'evenodd',
      d: 'M17.1613 1C18.7291 1 20 2.25985 20 3.81395V20.186C20 21.7402 18.7291 23 17.1613 23H6.83871C5.27093 23 4 21.7401 4 20.186V3.81395C4 2.25985 5.27093 1 6.83871 1H17.1613ZM6.83871 2.53488C6.12608 2.53488 5.54839 3.10754 5.54839 3.81395V20.186C5.54839 20.8925 6.12608 21.4651 6.83871 21.4651H17.1613C17.8739 21.4651 18.4516 20.8925 18.4516 20.186V3.81395C18.4516 3.10754 17.8739 2.53488 17.1613 2.53488H15.6562L15.0353 4.38354C14.7894 5.11445 14.0988 5.60745 13.3216 5.60765H10.6804C9.90308 5.60765 9.21277 5.11447 8.96673 4.38354L8.34476 2.53488H6.83871ZM10.4355 3.89789C10.4707 4.00223 10.5694 4.07277 10.6804 4.07277H13.3216C13.4324 4.07257 13.5304 4.00205 13.5655 3.89789L14.0242 2.53488H9.97681L10.4355 3.89789Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      fillRule: 'evenodd',
      key: '1'
    }
  ]
];

export const PhoneOff01: IconSvgObject = [
  [
    'path',
    {
      d: 'M13.0233 18.3953C13.447 18.3953 13.7906 18.739 13.7907 19.1628C13.7907 19.5866 13.4471 19.9302 13.0233 19.9302H10.9767C10.5529 19.9302 10.2093 19.5866 10.2093 19.1628C10.2094 18.739 10.553 18.3953 10.9767 18.3953H13.0233Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      key: '0'
    }
  ],
  [
    'path',
    {
      'clip-rule': 'evenodd',
      d: 'M1.22478 1.22484C1.52449 0.925132 2.01029 0.925132 2.31 1.22484L22.7752 21.69C23.0749 21.9897 23.0749 22.4755 22.7752 22.7752C22.4755 23.0749 21.9897 23.0749 21.69 22.7752L19.8303 20.9155C19.5087 22.1155 18.4178 23 17.1163 23H6.88369C5.32958 23 4.06973 21.7401 4.06973 20.186V5.15498L1.22478 2.31005C0.925073 2.01034 0.925073 1.52454 1.22478 1.22484ZM5.60462 20.186C5.60462 20.8925 6.17728 21.4651 6.88369 21.4651H17.1163C17.8227 21.4651 18.3954 20.8925 18.3954 20.186V19.4806L5.60462 6.68986V20.186Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      fillRule: 'evenodd',
      key: '1'
    }
  ],
  [
    'path',
    {
      'clip-rule': 'evenodd',
      d: 'M17.1163 1C18.6704 1 19.9302 2.25995 19.9303 3.81395V15.0698C19.9303 15.4936 19.5867 15.8372 19.1628 15.8372C18.739 15.8372 18.3954 15.4936 18.3954 15.0698V3.81395C18.3953 3.10764 17.8227 2.53488 17.1163 2.53488H15.6234L15.0078 4.38054C14.7641 5.11169 14.0798 5.60463 13.3091 5.60465H10.6909C9.92023 5.60463 9.23593 5.11169 8.99217 4.38054L8.37662 2.53488H6.88369C6.7721 2.53488 6.66449 2.54871 6.56293 2.57485C6.15255 2.68031 5.73422 2.43363 5.6286 2.02326C5.52309 1.61285 5.7708 1.19456 6.1812 1.08894C6.40658 1.03096 6.6421 1 6.88369 1H17.1163ZM10.4481 3.89489C10.4829 3.99934 10.5809 4.06974 10.6909 4.06977H13.3091C13.4191 4.06974 13.5171 3.99934 13.5519 3.89489L14.0046 2.53488H9.99545L10.4481 3.89489Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      fillRule: 'evenodd',
      key: '2'
    }
  ]
];

export const Discoball: IconSvgObject = [
  [
    'path',
    {
      'clip-rule': 'evenodd',
      d: 'M9.9375 0.999512C10.3172 0.999512 10.625 1.30732 10.625 1.68701V5.15226C12.7441 5.31553 14.7449 6.22856 16.2584 7.74202C17.9344 9.4182 18.8759 11.6925 18.8759 14.0629C18.8757 16.4331 17.9344 18.7069 16.2584 20.3829C14.5823 22.0588 12.3086 23.0003 9.9384 23.0004C7.56801 23.0004 5.29368 22.0589 3.61751 20.3829C1.94154 18.7069 1.00023 16.4331 1 14.0629C1 11.6925 1.94146 9.4182 3.61751 7.74202C5.13065 6.22889 7.1313 5.31672 9.25 5.15316V1.68701C9.25 1.30732 9.5578 0.999512 9.9375 0.999512ZM6.94938 17.316C7.51386 19.2642 8.56219 20.7964 9.81307 21.6218C9.85482 21.6225 9.89657 21.6254 9.9384 21.6254C9.97932 21.6254 10.0202 21.6225 10.061 21.6218C11.312 20.7967 12.3601 19.2649 12.9247 17.3169C11.968 17.4362 10.9571 17.4986 9.9384 17.4986L9.93929 17.4995C8.93966 17.5022 7.94114 17.4399 6.94938 17.316ZM17.2046 16.1514C16.8425 16.3401 16.4338 16.5102 15.9898 16.6589L15.988 16.6598C15.5057 16.8202 14.9745 16.9577 14.4071 17.0743C14.0399 18.6476 13.3912 20.0566 12.5264 21.1671C13.5537 20.793 14.4983 20.1986 15.2862 19.4107C16.2001 18.4968 16.8538 17.3718 17.2046 16.1514ZM2.67131 16.1523C3.02239 17.3724 3.67684 18.497 4.59058 19.4107C5.37761 20.1976 6.32087 20.792 7.34684 21.1662C6.48252 20.0558 5.83401 18.647 5.46696 17.0743C4.89976 16.958 4.36869 16.82 3.88607 16.6589C3.44157 16.5111 3.0332 16.341 2.67131 16.1523ZM9.93571 11.9995C8.91152 11.9965 7.88814 12.0647 6.87329 12.2027L6.8724 12.2018C6.79323 12.2128 6.71474 12.2241 6.63696 12.2358C6.54789 12.8206 6.5 13.4314 6.5 14.062C6.5 14.692 6.54742 15.3018 6.63607 15.8855C6.7148 15.8973 6.79404 15.9103 6.87419 15.9213C7.88903 16.0596 8.91148 16.1273 9.93571 16.1245H9.9375C10.9915 16.1245 12.0327 16.0552 13.0008 15.9222C13.0804 15.9113 13.159 15.8982 13.2371 15.8864C13.3259 15.3023 13.375 14.6924 13.375 14.062C13.375 13.4316 13.327 12.8212 13.238 12.2367C13.16 12.225 13.0812 12.2136 13.0017 12.2027C11.9869 12.0644 10.9635 11.9968 9.93929 11.9995H9.93571ZM5.21452 12.5142C4.89646 12.5923 4.59771 12.6774 4.32113 12.7694L4.32023 12.7685C3.59509 13.0115 3.07308 13.2825 2.74829 13.5446L2.7474 13.5455C2.4153 13.8124 2.37504 13.9932 2.375 14.062C2.37504 14.131 2.41497 14.3124 2.7465 14.5794C3.03224 14.8095 3.46896 15.0456 4.05884 15.2625L4.32113 15.3538C4.59736 15.4459 4.89583 15.5319 5.21362 15.6098C5.15553 15.1041 5.125 14.5869 5.125 14.062C5.125 13.5373 5.1563 13.0202 5.21452 12.5142ZM14.6596 12.5142C14.7178 13.0202 14.75 13.5372 14.75 14.062C14.75 14.5869 14.7186 15.104 14.6605 15.6098C14.9785 15.5317 15.2772 15.4466 15.5539 15.3547C16.2793 15.1116 16.8018 14.8416 17.1267 14.5794L17.1276 14.5785C17.4597 14.3117 17.5 14.1308 17.5 14.062C17.5 13.993 17.4598 13.8124 17.1285 13.5455C16.8428 13.3154 16.4062 13.0785 15.8162 12.8616L15.5539 12.7703C15.2771 12.6779 14.978 12.5924 14.6596 12.5142ZM7.34863 6.95695C6.32181 7.33135 5.3782 7.92747 4.59058 8.71509C3.6773 9.62844 3.02246 10.7514 2.67131 11.9709C3.03311 11.7824 3.44173 11.6136 3.88517 11.4651L3.88696 11.4642C4.36964 11.3037 4.90051 11.1645 5.46785 11.0479C5.8352 9.4763 6.48431 8.06745 7.34863 6.95695ZM12.5255 6.95605C13.3904 8.06671 14.0388 9.47634 14.4062 11.0488C14.9735 11.1652 15.5044 11.3041 15.9871 11.4651C16.4318 11.6129 16.8416 11.7822 17.2037 11.9709C16.8527 10.7516 16.1992 9.62833 15.2862 8.71509C14.498 7.92684 13.5534 7.3304 12.5255 6.95605ZM9.81128 6.5022C8.56183 7.32659 7.51484 8.86009 6.95028 10.8062C7.94053 10.6829 8.93762 10.6226 9.93571 10.6254H9.9375C10.9359 10.6228 11.9342 10.6835 12.9247 10.8071C12.36 8.86004 11.3122 7.32672 10.0619 6.5022C10.0208 6.50152 9.97962 6.49951 9.9384 6.49951C9.89597 6.49951 9.85362 6.50149 9.81128 6.5022Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      fillRule: 'evenodd',
      key: '0'
    }
  ],
  [
    'path',
    {
      d: 'M20.9375 5.12451C21.3172 5.12451 21.625 5.43232 21.625 5.81201V6.49951H22.3125C22.6922 6.49951 23 6.80732 23 7.18701C23 7.56671 22.6922 7.87451 22.3125 7.87451H21.625V8.56201C21.625 8.94171 21.3172 9.24951 20.9375 9.24951C20.5578 9.24951 20.25 8.94171 20.25 8.56201V7.87451H19.5625C19.1828 7.87451 18.875 7.56671 18.875 7.18701C18.875 6.80732 19.1828 6.49951 19.5625 6.49951H20.25V5.81201C20.25 5.43232 20.5578 5.12451 20.9375 5.12451Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      key: '1'
    }
  ],
  [
    'path',
    {
      d: 'M16.8125 0.999512C17.1922 0.999512 17.5 1.30732 17.5 1.68701V2.37451H18.1875C18.5672 2.37451 18.875 2.68232 18.875 3.06201C18.875 3.44171 18.5672 3.74951 18.1875 3.74951H17.5V4.43701C17.5 4.81671 17.1922 5.12451 16.8125 5.12451C16.4328 5.12451 16.125 4.81671 16.125 4.43701V3.74951H15.4375C15.0578 3.74951 14.75 3.44171 14.75 3.06201C14.75 2.68232 15.0578 2.37451 15.4375 2.37451H16.125V1.68701C16.125 1.30732 16.4328 0.999512 16.8125 0.999512Z',
      fill: 'currentColor',
      'fill-opacity': '0.9',
      key: '2'
    }
  ]
];
